import React from 'react';
import { Tooltip as Tippy } from 'react-tippy';

import { isMobileWidth } from '../../theme/layoutUtilities';
import closeIcon from '../../images/cross-icon.svg';
import styles from './Tooltip.css';

/**
  Tooltip Component
*/
const Tooltip = ({ title, content, trigger = 'click', ...rest }) => (
    <Tippy
        trigger={trigger}
        html={
            <div className={isMobileWidth() ? 'tool-tip-mobile' : 'tool-tip'}>
                {title && <strong>{title}</strong>}
                {trigger === 'click' && (
                    <img src={closeIcon} alt="close tooltip" />
                )}
                {content && <div>{content}</div>}
                <style jsx>{styles}</style>
            </div>
        }
        {...rest}
    />
);

Tooltip.defaultProps = {};

Tooltip.propTypes = {};

export default Tooltip;

// make this take a child component to make content sections
